import {ErrorType} from '~/enums/ErrorType'
import NavigableValidator from '~/models/navigableValidators/navigableValidator'
import ValidationError from '~/models/validationError'
import {ProcessFlowTakeActionStep} from '~/models/processFlows/steps/processFlowTakeActionStep'

export default class ProcessFlowTakeActionStepReferenceValidator extends NavigableValidator<ProcessFlowTakeActionStep> {
  _validatorKey = 'action';
  defaultType = ErrorType.mustBePresent;

  _validate(model: ProcessFlowTakeActionStep): void {
    // variable, form, workflow step, action
    if (model.path.nodes.length !== 4 || !model.path.allReferencesLinked) {
      this.errors.push(this.buildValidationError(model, 'Action not configured'))
    }
  }

  buildValidationError(model: ProcessFlowTakeActionStep, value?, type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: model.titleOrDefault,
      errorNavOpts: model.validation.errorNavOpts(this, 'action', model),
      type: type || this.defaultType,
      section: this.section
    });
  }
}